/**
 * The trainer's agenda for a group (06.10.2026): how each kind of action
 * looks, and the few words around it. The list itself — what is due, what is
 * late — comes whole from `/portal/groups/:id/agenda`.
 */
const MONTHS = ["ian.", "feb.", "mar.", "apr.", "mai", "iun.", "iul.", "aug.", "sept.", "oct.", "nov.", "dec."];

export const LEVEL_LOOK = {
  late: { label: "Întârziat", tone: "late", rail: "bg-[#c0483f]" },
  todo: { label: "De făcut", tone: "neutral", rail: "bg-[#965EA7]" },
  info: { label: "De urmărit", tone: "info", rail: "bg-[#3F8EBA]" },
};

export function levelLook(level) {
  return LEVEL_LOOK[level] || LEVEL_LOOK.todo;
}

/** "până pe 7 oct." from "2026-10-07"; empty without a date. */
export function dueText(isoDate) {
  if (!isoDate) return "";
  const [y, m, d] = String(isoDate).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return "";
  return `până pe ${d} ${MONTHS[m - 1]}`;
}

/** What the group's card on the home page says: "3 de făcut", "totul e la zi". */
export function pendingText(counts) {
  const n = (counts?.late || 0) + (counts?.todo || 0);
  if (!n) return "Totul e la zi";
  return n === 1 ? "Un lucru de făcut" : `${n} lucruri de făcut`;
}

export function pendingTone(counts) {
  if (counts?.late) return "late";
  if (counts?.todo) return "warn";
  return "good";
}
